var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmailSubjectHover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 33,
    fill: "#fff",
    opacity: 0.001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16014.479-2137.6h-18.015a4.511,4.511,0,0,1-4.508-4.5V-2153.1a4.5,4.5,0,0,1,4-4.475v1.822a2.7,2.7,0,0,0-2.2,2.653v10.992a2.705,2.705,0,0,0,2.7,2.7h18.015a2.706,2.706,0,0,0,2.705-2.7V-2153.1a2.693,2.693,0,0,0-1.228-2.263v-1.994a4.506,4.506,0,0,1,3.03,4.256v10.992A4.511,4.511,0,0,1-16014.479-2137.6Z",
    transform: "translate(16038 2168.601)",
    fill: "#3953fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.054,11.046l3.541,2.633a.925.925,0,0,0,.894.2.87.87,0,0,0,.606-.659.837.837,0,0,0-.319-.823L20.236,9.753C19.317,8.989,17.833,10.027,19.054,11.046Z",
    transform: "translate(-0.821 13.587)",
    fill: "#3953fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.648,11.046l-3.541,2.633a.925.925,0,0,1-.894.2.87.87,0,0,1-.606-.659.837.837,0,0,1,.319-.823l3.541-2.641C23.385,8.989,24.869,10.027,23.648,11.046Z",
    transform: "translate(-12.82 13.587)",
    fill: "#3953fb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.514,6.571a4.431,4.431,0,0,0-3.164,1.38l-5.293,5.42a1.1,1.1,0,0,0-.3.961.964.964,0,0,0,.579.77.768.768,0,0,0,.854-.231l5.293-5.41a2.767,2.767,0,0,1,4.071,0l5.293,5.41a.768.768,0,0,0,.854.231.964.964,0,0,0,.579-.77,1.1,1.1,0,0,0-.3-.961l-5.293-5.42A4.431,4.431,0,0,0,14.514,6.571Z",
    transform: "translate(0 -6.073)",
    fill: "#959cf2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.942,14.765a4.1,4.1,0,0,1-2.958-1.318L6.035,8.269a1.061,1.061,0,0,1-.285-.918.919.919,0,0,1,.541-.735c.28-.107,15.021-.107,15.3,0a.919.919,0,0,1,.541.735,1.061,1.061,0,0,1-.285.918L16.9,13.447A4.1,4.1,0,0,1,13.942,14.765Z",
    transform: "translate(0.571 6.468)",
    fill: "#959cf2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailSubjectHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emailSubjectHover.5a0791f6.svg";
export { ForwardRef as ReactComponent };